import PropTypes from 'prop-types';
import { formatTierName } from 'utils/utils';

const TiersHeadLabel = ({ columnMeta, tier, currentTierName }) => {
  const headerStyle = {
    display: 'flex',
    alignItems: 'center',
    color: formatTierName(tier) !== currentTierName ? 'grey' : ''
  };

  return <div style={headerStyle}>{columnMeta.label}</div>;
};

TiersHeadLabel.propTypes = {
  tier: PropTypes.string,
  columnMeta: PropTypes.object,
  currentTierName: PropTypes.string
};

export default TiersHeadLabel;
